export default {
  sinisterCode: null,
  sinisterVersion: null,
  insurance: null,
  insured: null
}



// WEBPACK FOOTER //
// ./src/components/regulation/auto/sinisterheader/model/sinisterheadermodel.js